import Vue from 'vue'
import tool from '../tool/tool'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
const find = () => import('../views/find.vue')
const detail = () => import('../views/detail.vue')
const info = () => import('../views/info.vue')
const allCountry = () => import('../views/allCountry.vue')
const center = () => import('../views/personalCenter.vue')
const sub = () => import('../components/center/subscribe.vue')
const user = () => import('../components/center/user.vue')
const mydata = () => import('../components/center/data.vue')
const collect = () => import('../components/center/collect.vue')
const login = () => import('../views/login.vue')
const dataExport = () => import('../views/dataExport.vue')
const payOption = () => import('../components/export/payOption.vue')
const pay = () => import('../components/export/pay.vue')
const result = () => import('../components/export/result.vue')
const browse = () => import('../components/export/browse.vue')
const publicPage = () => import('../views/public.vue')
const customMade = () => import('../views/customMade.vue')
const translateOrder = () => import('../views/translate/order.vue')
const myTranslate = () => import('../components/center/myTranslate.vue')
const TranslateResult = () => import('../views/translate/result.vue')
const findInfo = () => import('../views/findInfo.vue')
const vip = () => import('../views/vip.vue')
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    }, 
    {
      path: '/TranslateResult',
      name: 'TranslateResult',
      component: TranslateResult,
      // meta: {
      //   auth: true, //添加字段判断该页面是否需要登录
      // },
    },
    {
      path: '/order',
      name: 'order',
      component: translateOrder,
    },
    {
      path: '/publicPage',
      name: 'publicPage',
      component: publicPage,
    },
    {
      path: '/customMade',
      name: 'customMade',
      component: customMade, 
      meta: {
        title: '牵星出海定制服务 - 北京中外翻译', 
      },
    },
    {
      path: '/find',
      name: 'multi',
      component: find,
    },{
      path: '/vip',
      name: 'vip',
      component: vip, 
      meta: {
        auth: true, //添加字段判断该页面是否需要登录
      },
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail,
    },
    {
      path: '/info',
      name: 'info',
      component: info,
    },
    {
      path: '/findInfo',
      name: 'findInfo',
      component: findInfo,
    },
    {
      path: '/allCountry',
      name: 'allCountry',
      component: allCountry,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/browse',
      name: 'browse',
      component: browse,
    },
    {
      path: '/export',
      name: 'export',
      component: dataExport,
      redirect: '/payOption',
      meta: {
        auth: true, //添加字段判断该页面是否需要登录
      },
      children: [
        {
          path: '/payOption',
          name: 'payOption',
          component: payOption,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
            keepAlive: true,
          },
        },
        {
          path: '/pay',
          name: 'pay',
          component: pay,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
        {
          path: '/result',
          name: 'result',
          component: result,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
      ],
    },
    {
      path: '/center',
      name: 'center',
      component: center,
      redirect: '/user',
      meta: {
        auth: true, //添加字段判断该页面是否需要登录
      },
      children: [
        {
          path: '/mytranslate',
          name: 'mytranslate',
          component: myTranslate,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
        {
          path: '/subscribe',
          name: 'subscribe',
          component: sub,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
        {
          path: '/user',
          name: 'user',
          component: user,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
        {
          path: '/mydata',
          name: 'mydata',
          component: mydata,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
        {
          path: '/collect',
          name: 'collect',
          component: collect,
          meta: {
            auth: true, //添加字段判断该页面是否需要登录
          },
        },
      ],
    },
  ],
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // to要跳转到的路径
  // from从哪个路径来
  // next往下执行的回调
  let metaKey = document.querySelector('meta[name="Keywords"]');
  let metaDes = document.querySelector('meta[name="Description"]');
  if (to.meta.title) {
    document.title = to.meta.title;
    metaKey.setAttribute('content', '商机服务，牵星出海，企业出海，海外招标，中外翻译');
    metaDes.setAttribute('content', '牵星出海平台为企业提供全方位的商机服务，量身打造适合自身海外发展的市场营销方案，帮助企业拓展更广阔的的海外市场。');
  } else {
    document.title = '牵星出海 -- 汇聚全球标讯 助力企业出海';
    metaKey.setAttribute('content', '海外资讯,企业出海,海外招标,海外投标,一带一路,招标订阅,招标推送,招标信息,招标公告');
    metaDes.setAttribute('content', '牵星出海为用户提供个性化定制的海外全行业招标信息订阅推送服务，并结合海外行业动态，为用户提供多方位的智能信息服务。');
  }
  // 在localStorage中获取token
  let token = tool.getCookie('user')
  // 判断该页面是否需要登录
  if (to.meta.auth) {
    // 如果token存在直接跳转
    if (token) {
      next()
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
        // 跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
      })
    }
  } else {
    // 如果不需要登录，则直接跳转到对应页面
    next()
  }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}
export default router
